import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import noImg from "../../../Assets/common/no-preview.png";
import TrashL from "@semcore/ui/icon/Trash/l";
import Button from "@semcore/button";

const UploadImage = ({ type, Logo, onChange, note, resetLogo }) => {
  const handleDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    onChange(file);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    onChange(file);
    document.getElementById(`file-input-${type}`).value = "";
  };

  return (
    <div className="upload-logo-container">
      <img src={Logo?.src || noImg} alt="logo" className="logo" />
      <div>
        <div className="d-flex align-items-center">
          <div
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            className="logo-upload"
          >
            <label
              htmlFor={`file-input-${type}`}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                color: "#6C6E79"
              }}
              className="d-flex align-items-center justify-content-center gap-2 w-100 h-100 point"
            >
              <CloudUploadIcon />
              <p className="mb-0">UPDATE LOGO</p>
            </label>
            <input
              id={`file-input-${type}`}
              name={`file-input-${type}`}
              type="file"
              accept="image/*, application/pdf"
              onChange={handleFileChange}
              style={{ display: "none" }}
            />
          </div>
          {Logo?.src && (
            <Button title="remove" ml={2} h={38} onClick={resetLogo}>
              <Button.Addon>
                <TrashL />
              </Button.Addon>
            </Button>
          )}
        </div>
        <small className="text-muted">({note})</small>
      </div>
    </div>
  );
};

export default UploadImage;
